import * as PIXI from 'pixi.js';
import { CavernsStore } from '~/flux/stores';
import CavernsUnitDetailsView from './CavernsUnitDetailsView';

const UnitDetailsPanel = function ({ loadout_squad_list, onUnitViewsCreated }) {
  PIXI.Container.call(this);

  let _unitDetailsViews = [];
  let _update_interval;

  this.dispose = () => {
    clearInterval(_update_interval);

    CavernsStore.removeListener(CavernsStore.BATTLE_EVENT, update);
    CavernsStore.removeListener(CavernsStore.GOT_UNIT_STATE, update);

    destroyUnitDetailsViews();
    this.destroy();
  };

  const destroyUnitDetailsViews = () => {
    if (_unitDetailsViews) {
      for (let i = 0; i < _unitDetailsViews.length; ++i) {
        _unitDetailsViews[i].dispose();
      }
      _unitDetailsViews = null;
    }
  };

  const makeUnitDetailsViews = () => {
    destroyUnitDetailsViews();
    _unitDetailsViews = [];

    const { battleState } = CavernsStore.getAll();
    if (!battleState) return;

    const all_units_list = Object.values(battleState.allUnits);

    for (let i = 0; i < loadout_squad_list.length; ++i) {
      const loadout_member = loadout_squad_list[i];
      const hero_handle = loadout_member.hero_handle || loadout_member.handle;
      const unit_state = all_units_list.find(({ hero_handle: hh }) => hh === hero_handle);

      const udv = new CavernsUnitDetailsView(unit_state, loadout_member);
      const prev_udv = _unitDetailsViews[i - 1];
      if (prev_udv) {
        udv.y = Math.round(prev_udv.y + prev_udv.height + DT_CANVAS_GLOBALS.spacing * 2);
      }
      this.addChild(udv);
      _unitDetailsViews.push(udv);
    }
    onUnitViewsCreated(this);

    clearInterval(_update_interval);
    _update_interval = setInterval(() => {
      for (const view of _unitDetailsViews || []) {
        view.updateStats();
      }
    }, 33);
  };

  const update = (data) => {
    const { battleState } = CavernsStore.getAll();
    if (!battleState) {
      return;
    }

    if (data?.event?.eventHandle === 'death') {
      for (const view of _unitDetailsViews) {
        if (data?.event?.victimId === view.unit_state.uid) {
          view.onUnitDeath();
          return;
        }
      }
    }
  };

  makeUnitDetailsViews();

  CavernsStore.on(CavernsStore.BATTLE_EVENT, update);
  CavernsStore.on(CavernsStore.GOT_UNIT_STATE, update);
};
UnitDetailsPanel.prototype = Object.create(PIXI.Container.prototype);
UnitDetailsPanel.prototype.constructor = UnitDetailsPanel;
export default UnitDetailsPanel;
